<template>
  <div class="tva-paragraph-component tva-row" :id="`section-${slug(content.title)}`">
    <h4 class="paragraph-small-title tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-3" v-html="content.title">{{content.title}}</h4>

    <div class="paragraph tva-col-md-offset-0 tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-7">
      <p>{{content.text}}</p>
      <ul>
        <p v-for="(bullet, index) in content.list" :key="index">{{bullet}}</p>
      </ul>
    </div>
  </div>
</template>
<script>
import slugify from 'slugify';
export default {
  props: ["content"],
   methods: {
    slug(string) {
      if (string) {
         return slugify(string, {
        lower: true,
        remove: "'"
      })
      } else {
        return ''
      }
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";

.tva-paragraph-component {
  font-family: "Avenir next";
  font-size: 0.9rem;
  .paragraph {
    padding: 0;
  }
  .paragraph-title,
  .paragraph-small-title {
    padding: 0;
    margin-bottom: 20px;
  }
  ul {
    padding-inline-start: 20px;
    p {
      font-family: "Avenir next";
      list-style: none;
      padding-left: 1em;
      padding-bottom: 1em;
      position: relative;
      &::before {
        position: absolute;
        background: $eni-yellow;
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        left: -20px;
        top: 13px;
      }
    }
  }
}
@media(max-width: 1024px) {
  .tva-paragraph-component {
    display:flex;
    flex-direction: column;
  }
}
</style>
